import React from "react";
import { LegalLayout, Section, P } from "../components/legal/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout
      testId="privacy-page"
      eyebrow="Privacy · Canada"
      title="Privacy Policy"
      intro="This Policy explains how the SmartPeptides Hub collects, uses, protects, retains, and discloses personal information in a manner intended to align with PIPEDA and Canadian privacy expectations."
      updatedOn="July 2026"
    >
      <Section number="01" title="Information we collect">
        <P>
          When you activate the SmartPeptides Hub, we collect your email address and validate the
          distributor code printed with your product. We create a permanent association between
          that email address and the distributor relationship so you can access post-purchase
          support without a password.
        </P>
        <P>
          We may also collect limited technical information needed to operate and secure the Hub,
          such as device, browser, approximate region, access timestamps, security logs, and basic
          interaction data. The Hub itself does not request diagnosis, laboratory results, or other
          clinical data.
        </P>
      </Section>

      <Section number="02" title="Connected services">
        <P>
          If you choose to use connected services such as LIA or Smartplaite, those services may
          collect health, biomarker, nutrition, activity, protocol, or coaching information that
          you expressly provide. That information should be used only to deliver the features you
          request, personalize your experience, support safety and service quality, and meet legal
          or regulatory obligations.
        </P>
        <P>
          SmartPeptides does not sell personal information or health information. Health-related
          information should be handled with enhanced safeguards and accessed only by authorized
          personnel or service providers with a legitimate operational need.
        </P>
      </Section>

      <Section number="03" title="Consent">
        <P>
          By activating the Hub, you consent to the collection, use, retention, and disclosure of
          your email address and distributor relationship for the purposes described in this
          Privacy Policy. Where connected health features require additional information, those
          purposes should be explained before collection.
        </P>
        <P>
          You may withdraw consent, subject to legal or contractual restrictions, by contacting the
          Privacy Officer. Withdrawal may limit or prevent access to the Hub or connected services
          because your email and distributor relationship are required to operate them.
        </P>
      </Section>

      <Section number="04" title="Third-party processors and links">
        <P>
          We may use carefully selected service providers for hosting, databases, security,
          analytics, customer support, application distribution, and communications. These
          processors are permitted to handle personal information only for the purposes we
          authorize, under appropriate confidentiality and security obligations.
        </P>
        <P>
          The Hub may also link to third-party applications, distributor portals, or partner
          services. We are not responsible for the privacy practices of third parties, and we
          encourage you to review their policies before providing information.
        </P>
      </Section>

      <Section number="05" title="Retention and deletion">
        <P>
          We retain activation information for as long as needed to maintain your post-purchase
          access, preserve distributor attribution, prevent fraud, resolve disputes, and satisfy
          legal or accounting requirements. When information is no longer required, it should be
          securely deleted, anonymized, or aggregated.
        </P>
        <P>
          You may request deletion of your personal information. Deleting your activation may
          remove access to reorder convenience, connected ecosystem features, and
          distributor-linked support.
        </P>
      </Section>

      <Section number="06" title="Your PIPEDA rights">
        <P>
          Subject to applicable law, you may request access to your personal information, ask how
          it has been used or disclosed, request correction of inaccurate or incomplete
          information, withdraw consent, and challenge our compliance with the Personal
          Information Protection and Electronic Documents Act (PIPEDA).
        </P>
        <P>
          We may need to verify your identity before fulfilling a request. If we cannot fulfill a
          request in full, we will explain the reason unless prohibited by law.
        </P>
      </Section>

      <Section number="07" title="Security safeguards">
        <P>
          We use administrative, technical, and physical safeguards proportionate to the
          sensitivity of the information, including access controls, encryption in transit, hashed
          distributor-code comparisons, audit logging, least-privilege access, and vendor review.
        </P>
        <P>
          No method of transmission or storage is completely secure. You should keep your device
          protected, avoid sharing your distributor code publicly, and contact us promptly if you
          suspect unauthorized use.
        </P>
      </Section>

      <Section number="08" title="Governing law and contact">
        <P>
          This Privacy Policy is governed by the laws of Alberta and the federal laws of Canada
          applicable there, including PIPEDA. Any privacy concern should first be directed to our
          Privacy Officer so we can investigate and respond.
        </P>
        <P>
          Privacy Officer: privacy@smartpeptides.ai (placeholder contact). Mailing address:
          c/o Urban Lawyers, Edmonton, Alberta.
        </P>
      </Section>

      <Section number="09" title="Medical disclaimer">
        <P>
          Content in the Hub and connected services is provided for informational and
          organizational purposes only. It is not medical advice, diagnosis, treatment, or a
          substitute for consultation with a qualified physician, pharmacist, or other regulated
          health professional.
        </P>
        <P>
          Always seek professional guidance before starting, stopping, or changing any peptide,
          medication, supplement, nutrition, exercise, or health protocol.
        </P>
      </Section>
    </LegalLayout>
  );
}
